import { View } from 'react-native';

import styled from 'styled-components/native';

export const IconContainer = styled(View)`
  padding-top: 10px;
  padding-bottom: 20px;
  align-items: center;
`;

export const Circle = styled(View)`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
`;
